export default class AuthController {
  constructor(httpsClient, routeService) {
    this.httpsClient = httpsClient;
  }

  async login(credentials) {
    return await this.httpsClient.post("user/login", credentials);
  }

  async googleOAuth(credentials) {
    return await this.httpsClient.post("user/googleOAuth", credentials);
  }
}
